import WsService from "../WsService";
import ChatConversation from "../../domain/chat/ChatConversation";
import BasicAuthGenerator from "../../utils/BasicAuthGenerator";
import UserSessionService from "../UserSessionService";


const ENDPOINT_BASE = '/chat/conversation';

export default class ChatConversationService{

    static createConversation(conversationCreateRequest){

        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();
        let headers = {
            "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"]),
        };

        return WsService.postWithHeaders(ENDPOINT_BASE, conversationCreateRequest, 201, headers).then(
            response => {
                return new ChatConversation(response);
            },
            response => {
                return response;
            }
        );
    }

    static retrieveConversation(conversationId) {

        let url = ENDPOINT_BASE + '/'+conversationId
        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();
        let headers = {
            "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"]),
        };

        return WsService.getWithHeaders(url, {}, 200, headers).then(
            response => {
                return new ChatConversation(response);
            },
            response => {
                return response;
            }
        );
    }
}